(function () {
  const initTestimonials = () => {
    $(".testimonials-section").each(function () {
      if ($(this).hasClass("slider_started")) {
        return "";
      }
      $(this).addClass("slider_started");
      const id = $(this).attr("id");
      const box = $(this).find(".testimonials");
      const autoplay = box.data("autoplay");
      //const isLoop = box.data("loop");
      const stopAutoplay = box.data("stop-autoplay");
      const delay = box.data("delay") * 1000;
			const layout = box.data('layout');
			const perRow = layout == 'default' ? 1 : 1.8;
			const slideEffect = layout == 'default' ? 'fade': 'slide';

			if (box.find(".swiper-slide").length <= 1) {
				return;
			}
			
      let autoplayParam;
      if (autoplay) {
        autoplayParam = {
          autoplay: {
            delay: delay,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false,
          },
        };
      } else {
        autoplayParam = { autoplay: false };
      }

      const swiperReviewsParams = {
				speed: box.data("speed") * 1000,
				effect: slideEffect,
        loop: false,
				slidesPerView: 1,
        ...autoplayParam,
        centeredSlides: false,
				spaceBetween: 16,
        allowTouchMove: true,
        navigation: {
          nextEl: `#${id} .swiper-btn--next`,
          prevEl: `#${id} .swiper-btn--prev`,
        },
        breakpoints: {
          990: {
            keyboard: true,
          },
					1200: {
						slidesPerView: perRow,
          },
        },
        pagination: {
					el: `#${id} .swiper-pagination`,
					type: "fraction",
						renderFraction: function (currentClass, totalClass) {
							return `<span class="${currentClass}"></span> <div class="divider"></div> <span class="${totalClass}"></span>`;
					},
				},
				on: {
          slideChange: function () {
            document.querySelector(`#${id} .swiper-btn--prev`);
            document.querySelector(`#${id} .swiper-btn--next`);
          },
        },
      };

      const swiperReviews = new Swiper(`#${id} .testimonials__swiper`, {
        ...swiperReviewsParams,
      });

    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    initTestimonials();
    document.addEventListener("shopify:section:load", function () {
      initTestimonials();
    });
		
  });
	window.addEventListener("resize", function () {
		initTestimonials();
	});
})();
